import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/page_join_1.webp'
import _imports_1 from '../images/page_join_2.webp'
import _imports_2 from '../images/page_join_3.webp'
import _imports_3 from '../images/mobile_page_join_1.webp'
import _imports_4 from '../images/mobile_page_join_2.webp'
import _imports_5 from '../images/mobile_page_join_3.webp'
import _imports_6 from '../images/mobile_page_join_4.webp'
import _imports_7 from '../images/mobile_page_join_5.webp'
import _imports_8 from '../images/mobile_page_join_6.webp'
import _imports_9 from '../images/mobile_page_join_7.webp'


const _withScopeId = n => (_pushScopeId("data-v-07c4f978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tetrapak-page-join" }
const _hoisted_2 = { class: "content1 d-none d-md-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "img-fluid"
}, null, -1))
const _hoisted_4 = { class: "tetrapak-jump-btn jump-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" こちら ")
const _hoisted_6 = { class: "content2 d-none d-md-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "img-fluid"
}, null, -1))
const _hoisted_8 = { class: "tetrapak-jump-btn" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" アカウントを開設する ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content3 d-none d-md-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    class: "img-fluid"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content1 d-block d-md-none" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "",
    class: "img-fluid"
  })
], -1))
const _hoisted_12 = { class: "content2 d-block d-md-none mobile-x-scroll" }
const _hoisted_13 = { class: "img-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "img"
}, null, -1))
const _hoisted_15 = { class: "content3 d-flex d-md-none" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "child1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "",
    class: "img-fluid"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "child2 mobile-x-scroll" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "",
    class: "img"
  })
], -1))
const _hoisted_18 = { class: "child3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "",
  class: "img-fluid"
}, null, -1))
const _hoisted_20 = { class: "tetrapak-jump-btn" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" こちら ")
const _hoisted_22 = { class: "child4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "",
  class: "img-fluid"
}, null, -1))
const _hoisted_24 = { class: "tetrapak-jump-btn" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" アカウントを開設する ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content4 d-block d-md-none" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: "",
    class: "img-fluid"
  })
], -1))

import { inject } from 'vue';

type MenuKey = 'main' | 'join' | 'map' | 'about' | 'about-recycling' | 'faq';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const navToPageByKey = inject<(key: MenuKey) => void>('navToPageByKey');

function handleJump(key: MenuKey) {
  if (navToPageByKey) {
    navToPageByKey(key);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "tetrapak-jump-btn jump-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleJump('map')))
      }, " こちら "),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/points",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "/signup",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_10,
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", {
          class: "tetrapak-jump-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleJump('map')))
        }, " こちら ")
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_router_link, {
            to: "/points",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: "/signup",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_26
  ]))
}
}

})